module.exports = __webpack_public_path__ + "static/img/1.ce884bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/1.png
// module id = JwEX
// module chunks = 4